import { useBankingSDKConnectorsRecipientsPivotActions } from "features/openBanking/actions";
import { useOpenBankingResource } from "../shared/OpenBankingResource";

export default function useBankingSDKConnectorsRecipientsPivot() {
    const { onRowClick } = useOpenBankingResource();

    const {
        getBankingSDKConnectorsRecipientsPivot: getResource,
        downloadCsv
    } = useBankingSDKConnectorsRecipientsPivotActions();

    return {
        downloadCsv,
        getResource,
        onRowClick
    };
};
